export default __webpack_public_path__ + "static/media/detail_three.e3a3c869.png";